import {ISnackbarMessage} from '@components/@ui/Snackbar/MeinSnackbar';
import {BusEventEnum, EventBus} from '@core/eventBus';

export const sendSnackbarMessage = (message: ISnackbarMessage) => {
    EventBus.send<ISnackbarMessage>({
        key: BusEventEnum.SNACKBAR_MESSAGE,
        data: message,
    });
};
